import { useAuth } from "@/contexts/auth/useAuth";
import { cn } from "@/lib/utils";
import { Box } from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router";
import LogoPng from "/logo.png";

interface Props {
    /**
     * Styles to apply to the `img` element
     */
    style?: React.CSSProperties;
    className?: string;
}

/**
 * A component for the logo that navigates to the correct page based on the user's role
 */
export const Logo = ({ style, className }: Props) => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const { organizationId } = useParams<{ organizationId: string }>();

    const handleClick = () => {
        // If user is not logged in, navigate to login page
        if (!user) {
            navigate("/login");
            return;
        }

        // If user is admin, navigate to admin page
        if (user?.is_admin) {
            navigate("/admin");
        } else {
            // If user is not admin, navigate to organization page
            const organizationLink = organizationId
                ? `/organizations/${organizationId}/home`
                : "/organizations";

            navigate(organizationLink);
        }
    };

    return (
        <Box display="flex" onClick={handleClick} sx={{ cursor: "pointer" }}>
            <img
                src={LogoPng}
                alt="ContractScope Logo"
                style={style}
                className={cn(className)}
            />
        </Box>
    );
};
